import { useTheme } from "@mui/material";
import { useState } from "react";

import * as sx from "./fill-viewport.sx";

export const FULL_VIEWPORT = "--FullViewport-height";

export interface FillViewportProps extends React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
> {
  ignorePosition?: boolean;
  fullHeight?: boolean;
}

function getOffsetTop(el: HTMLElement) {
  let top = 0;
  let target: HTMLElement | null = el;
  while (target) {
    top += target.offsetTop;
    target = target.offsetParent as HTMLElement | null;
  }
  return top;
}

/**
 * FillViewport will allow the component to grow to fill the viewport while
 * attempting to prevent scrolling
 *
 * If `fullHeight` is true, the component will expand regardless of the size
 * of its content
 *
 * If `ignorePosition` is true, we will ignore the component's position and
 * allow it to expand to match the entire viewport
 */
export function FillViewport({
  fullHeight = false,
  ignorePosition = false,
  ...props
}: FillViewportProps) {
  const theme = useTheme();

  const MAX_CHROME_SPACING = `calc(100vh - var(${FULL_VIEWPORT}))`;

  const [relativeSpacing, setRelativeSpacing] = useState(MAX_CHROME_SPACING);

  const maxChromeSpacing = ignorePosition
    ? MAX_CHROME_SPACING
    : relativeSpacing;

  return (
    <sx.Root
      {...props}
      maxChromeSpacing={maxChromeSpacing}
      fullHeight={fullHeight}
      ref={(divRef) => {
        if (divRef) {
          const top = getOffsetTop(divRef);
          setRelativeSpacing(`calc(${top}px + ${theme.spacing(5)})`);
        }
      }}
    />
  );
}
